import { head, isBoolean, isString } from 'lodash'
import { isBrowser, value as GLOBAL_VALUE } from '../env'

const fetchModule = isBrowser() ? require('whatwg-fetch') : require('node-fetch')

const throttleUrls = {}

const setDefaultHeaders = (argOptions = {}) => {
  const options = argOptions || {}
  const existsHeaders = argOptions.headers || {}
  options.headers = {
    ...existsHeaders,
  }

  if (!!GLOBAL_VALUE['INFACE_VERSION'] && !isBrowser()) {
    options.headers['inface_sdk_version'] = GLOBAL_VALUE['INFACE_VERSION']
  }

  if (!!GLOBAL_VALUE['gid'] && !isBrowser()) {
    options.headers['gid'] = GLOBAL_VALUE['gid']
  }

  if (!!GLOBAL_VALUE['gsid'] && !isBrowser()) {
    options.headers['gsid'] = GLOBAL_VALUE['gsid']
  } else if (!isBrowser()) {
    options.headers['gsid'] = '' // gsid가 설정되기 전에는 키는 있되, 빈 문자열로 보내기로 함. 논의 슬랙채널.
  }

  if (!!GLOBAL_VALUE['channel_id'] && !isBrowser()) {
    options.headers['channel_id'] = GLOBAL_VALUE['channel_id']
  }

  if (!!GLOBAL_VALUE['world_id'] && !isBrowser()) {
    options.headers['world_id'] = GLOBAL_VALUE['world_id']
  }

  if (!!GLOBAL_VALUE['guid'] && !isBrowser()) {
    options.headers['guid'] = GLOBAL_VALUE['guid']
  }

  if (!!GLOBAL_VALUE['gcid'] && !isBrowser()) {
    options.headers['gcid'] = GLOBAL_VALUE['gcid']
  }

  return options
}

export const Fetch = (url, argOptions = {}) => {
  const options = setDefaultHeaders(argOptions)
  const basicSendTermTime = 100 //ms
  const ignoreSafe = options && isBoolean(options.unsafe) ? options.unsafe : false
  const urlQuery = url && isString(url) ? url : ''
  const methodQuery = options && options.method ? `${options.method}` : ''
  const headerQuery = options && options.headers ? Object.values(options.headers).join('+') : ''

  const throttleQuery = `${urlQuery}+${methodQuery}+${headerQuery}`
  const handler = throttleUrls[throttleQuery]

  return new Promise((resolve, reject) => {
    if (!url && isString(url)) {
      return reject('invalid parameter with url')
    }

    const realFetch = fetchModule.default || fetchModule.fetch

    if (handler) {
      handler.sendedCount += 1
      handler.waitTime = ignoreSafe ? 0 : (handler.waitTime + (handler.sendedCount * 50))
      const waitTime = handler.waitTime
      const beforeClear = handler.clear
      clearTimeout(beforeClear)
      handler.clear = setTimeout(() => {
        clearTimeout(handler.clear)
        delete throttleUrls[throttleQuery]
      }, handler.waitTime + basicSendTermTime)

      setTimeout(() => {
        handler.debugLastestSendedTime = new Date().getTime()
        const fetchProcessing = options ? realFetch(url, options) : realFetch(url)
        fetchProcessing.then(resolve).catch(reject)
      }, waitTime)
    } else {
      const newClearHandler = setTimeout(() => {
        clearTimeout(newClearHandler)
        delete throttleUrls[throttleQuery]
      }, basicSendTermTime)
      const newHandler = { sendedCount: 0, waitTime: 0, clear: newClearHandler }
      throttleUrls[throttleQuery] = newHandler
      setTimeout(() => {
        newHandler.debugLastestSendedTime = new Date().getTime()
        const fetchProcessing = options ? realFetch(url, options) : realFetch(url)
        fetchProcessing.then(resolve).catch(reject)
      }, 0)
    }
  })
}


export default {
  Fetch,
  FetchRaw: fetchModule,
  ...fetchModule
}

